import { Stack } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { Title } from './Title';
import { ISuppliersResult } from 'API/Suppliers/suppliers';
import { RequestSharePanel } from '../../Therapy/Summary/RequestSharePanel';

interface ISummary {
  data: ISuppliersResult;
}
export const Summary = ({ data }: ISummary) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='space-between'
      sx={{
        mb: isDesktop ? undefined : '24px',
      }}
    >
      <Title name={data.name} />
      <RequestSharePanel data={data} />
    </Stack>
  );
};
